import type { PaymentMethodData } from "../components/affiliate/PaymentInfoForm";

/** Count of payout methods with at least one non-empty field. */
export function countFilledMethods(data: PaymentMethodData[]): number {
  return data.filter((method) =>
    method.fieldValues.some((field) => field.value && field.value.trim() !== "")
  ).length;
}
